// extracted by mini-css-extract-plugin
export default {"pulse":"components-general-skeleton-module__pulse","skeleton-pulse":"components-general-skeleton-module__skeleton-pulse"};